/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecordingWestburyContributionsInner
 */
export interface RecordingWestburyContributionsInner {
    /**
     * 
     * @type {string}
     * @memberof RecordingWestburyContributionsInner
     */
    contribution: string;
    /**
     * 
     * @type {string}
     * @memberof RecordingWestburyContributionsInner
     */
    confidencePattern: string;
    /**
     * 
     * @type {string}
     * @memberof RecordingWestburyContributionsInner
     */
    confidenceCategory: string;
}

/**
 * Check if a given object implements the RecordingWestburyContributionsInner interface.
 */
export function instanceOfRecordingWestburyContributionsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "contribution" in value;
    isInstance = isInstance && "confidencePattern" in value;
    isInstance = isInstance && "confidenceCategory" in value;

    return isInstance;
}

export function RecordingWestburyContributionsInnerFromJSON(json: any): RecordingWestburyContributionsInner {
    return RecordingWestburyContributionsInnerFromJSONTyped(json, false);
}

export function RecordingWestburyContributionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordingWestburyContributionsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'contribution': json['contribution'],
        'confidencePattern': json['confidencePattern'],
        'confidenceCategory': json['confidenceCategory'],
    };
}

export function RecordingWestburyContributionsInnerToJSON(value?: RecordingWestburyContributionsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'contribution': value.contribution,
        'confidencePattern': value.confidencePattern,
        'confidenceCategory': value.confidenceCategory,
    };
}

